import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 15 * 1000; //轮询时间间隔

/**
 * * 学院报到率实时展示面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            cardData: [], //学院报到率统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取学院报到率数据
     *
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getRateOfCollegeReported', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, cardData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 构造学院报到率排名数据
     * @memberof Home
     */
    getRateOfCollegeReportedOption = () => {

        const { cardData = [] } = this.state;

        return cardData.map((item, index) => {
            return (
                <div
                    className={styles.bottom_item}
                    key={item.pm}
                >
                    <span
                        className={classNames(
                            styles.px,
                            {
                                [styles.px_1]:
                                    item.pm == 1,
                                [styles.px_2]:
                                    item.pm == 2,
                                [styles.px_3]:
                                    item.pm == 3
                            }
                        )}
                    >
                        {item.pm}
                    </span>
                    <span className={styles.zy}>
                        {item.xymc}
                    </span>
                    <span
                        className={classNames(
                            styles.num,
                            {
                                [styles.px_1]:
                                    item.pm == 1,
                                [styles.px_2]:
                                    item.pm == 2
                            }
                        )}
                    >
                        {
                            (item.bdl == 0 || item.bdl == 1) ? `${item.bdl*100}%` : `${parseFloat(item.bdl * 100).toFixed(2)}%`
                        }
                    </span>
                </div>
            );
        });
    }

    render() {
        return (
            <div className={styles.bottom_list}>
                {this.getRateOfCollegeReportedOption()}
            </div>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-bgy/_CardBox4.js